const ID_LIST_KEYS = ['facilities_ids', 'positions_ids', 'user_groups_ids'];
const PLAIN_KEYS = ['status', 'registration_status', 'search', 'date_added_after', 'date_added_before'];

/**
 * Filters of the user list page in the shape the API expects them.
 * They are kept in the URL so that they survive leaving the page and coming back.
 */
export const getDefaultUserListFilters = () => ({
  facilities_ids: [],
  positions_ids: [],
  user_groups_ids: [],
  date_added_before: '',
  date_added_after: '',
  status: 'active',
  registration_status: 'all',
  search: '',
  role_ids: [],
});

const parseId = (value) => (value !== '' && !isNaN(Number(value)) ? Number(value) : value);

/**
 * @param {URLSearchParams} searchParams
 * @returns {object} - filters for the user list, falling back to the defaults for anything not in the URL.
 */
export const parseUserListFilters = (searchParams) => {
  const filters = getDefaultUserListFilters();

  ID_LIST_KEYS.forEach((key) => {
    filters[key] = searchParams.getAll(key).map(parseId);
  });

  PLAIN_KEYS.forEach((key) => {
    if (searchParams.has(key)) {
      filters[key] = searchParams.get(key);
    }
  });

  if (searchParams.has('role_ids')) {
    filters.role_ids = parseId(searchParams.get('role_ids'));
  }

  if (searchParams.has('ordering')) {
    filters.ordering = searchParams.get('ordering');
  }

  return filters;
};

/**
 * @param {URLSearchParams} searchParams
 * @returns {number} - the current page, 1 when the URL holds no valid page.
 */
export const parseUserListPage = (searchParams) => {
  const page = Number(searchParams.get('page'));

  return Number.isInteger(page) && page > 0 ? page : 1;
};

/**
 * Reverse of `parseUserListFilters` / `parseUserListPage`. Default values are left out to keep the URL short.
 *
 * @param {object} filters
 * @param {number} page
 * @returns {URLSearchParams}
 */
export const userListFiltersToSearchParams = (filters, page) => {
  const searchParams = new URLSearchParams();
  const defaultFilters = getDefaultUserListFilters();

  ID_LIST_KEYS.forEach((key) => {
    (filters[key] || []).forEach((value) => searchParams.append(key, value));
  });

  PLAIN_KEYS.forEach((key) => {
    if (filters[key] && filters[key] !== defaultFilters[key]) {
      searchParams.set(key, filters[key]);
    }
  });

  // an array means "All" roles, which is the default
  if (filters.role_ids != null && !Array.isArray(filters.role_ids)) {
    searchParams.set('role_ids', filters.role_ids);
  }

  if (filters.ordering) {
    searchParams.set('ordering', filters.ordering);
  }

  if (page > 1) {
    searchParams.set('page', page);
  }

  return searchParams;
};
